/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Ad_Job_TitleInputs */



/**
* | output |
* | --- |
* | "Confirm AD Job Submission" |
*
* @param {Confirm_Ad_Job_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const confirm_ad_job_title = /** @type {((inputs?: Confirm_Ad_Job_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Ad_Job_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Confirmer la soumission de l'offre d'emploi")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bestätigung der AD-Stelleneinreichung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Conferma l'invio della candidatura per l'annuncio di lavoro.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подтвердите отправку задания на размещение рекламы.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Confirmar el envío de la oferta de empleo de AD")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("确认广告职位提交")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AD求人応募の確認")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विज्ञापन नौकरी सबमिशन की पुष्टि करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Confirmar envio de vaga de emprego para anúncio de emprego")
	return /** @type {LocalizedString} */ ("Confirm AD Job Submission")
});